export const generateMetricPercentage = (percent) => {
  percent = percent || 0;
  percent = percent * 100;
  percent = percent.toFixed(0);

  if (percent > 100) {
    percent = 100;
  }

  return percent + "%";
};

export const generateTimeSpent = (timeSpent: number) => {
  const minutes = Math.floor(timeSpent / 60);
  const seconds = Math.floor(timeSpent % 60);
  if (minutes === 0 && seconds === 0) {
    return "";
  } else {
    return (
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0")
    );
  }
};

export const getEmailOpenEvent = (events, source) => {
  if (!events) {
    return null;
  }

  const viewEvents = events
    .filter((event) => {;
      return (event.type === "email_open" || (event.type === "link_clicked" && source === "Paperflite QuickSend")) && event.exclusion === false;
    })
    .sort((e1, e2) => {
      return e2.createdDate - e1.createdDate;
    });

  if (viewEvents.length > 0) {
    return viewEvents[0];
  }
}

export const getViewEvent = (events) => {
  if (!events) {
    return null;
  }
  const viewEvents = events
    .filter((event) => {
      return (
        (event.type === "collection_viewed" ||
          event.type === "asset_viewed" ||
          event.type === "link_clicked") &&
        event.exclusion === false
      );
    })
    .sort((e1, e2) => {
      return e2.createdDate - e1.createdDate;
    });

  if (viewEvents.length > 0) {
    return viewEvents[0];
  }
}